<template>
    <div :style="doFontSize" class="BOS" >
   {{ txt }} 
    </div>
</template>


<script>
export default {

  name: "IconConverter",
  props: {
    txt: {
      type: String,
      default: "1"
    },
    fontSize: {
      type: String,
      default: "20px"
    }
  },   
  computed: {
    doFontSize() {
      return {
        "font-size": this.fontSize,
        "line-height": this.fontSize,
      };
    }
  }
}
</script>
<style>
@font-face { 
  font-family: "BOSAstrology";
  src:url(../../assets/fonts/BOSAstrology2020.ttf) format("truetype");
 }
.BOS {
    font-family: "BOSAstrology";
    /* font-size: this.size ; */
}
</style> 